// UI texts: feed
export default {
  title: 'Feed',
  onBoard: '{n} on the board',
  filters: { all: 'All', rumors: 'Rumors', events: 'Events', friends: 'Friends', following: 'Following' },
  filtersAria: 'Filter the board',
  rumor: 'Rumor',
  reliability: { 1: 'unconfirmed', 2: 'likely', 3: 'confirmed' },
  reliabilityAria: 'Reliability: {r}',
  event: 'Event',
  world: 'World',
  notice: 'For you',
  friendShared: 'shared a story',
  friendMeta: '{ago} · friend',
  readStory: 'Read story',
  share: 'Share',
  shareText: '{name}: {title}',
  linkCopied: 'Link copied',
  horde: {
    tag: 'Horde · Live',
    bossTag: 'Boss · Live',
    text: 'Every survivor counts. Damage is shared; rewards unlock at 25% and 50%.',
    stat: '{t} left · {crowd}',
    cta: 'View event',
    healthAria: 'Horde health: {p}% left',
  },
  empty: {
    all: {
      title: 'The board is bare',
      body: 'Rumors, world events and stories from your friends get pinned here as they happen. Check back after your next run.',
    },
    rumors: {
      title: 'No rumors going round',
      body: 'When someone finds something rare, word gets out. Some of it is even true.',
    },
    events: {
      title: 'Nothing happening out there',
      body: 'Hordes, weather and supply drops show up here. The evening horde always makes the board.',
    },
    friends: {
      title: 'No stories from friends',
      body: 'When a friend escapes with 4 HP or finds a Legendary, their story card lands here.',
      action: 'Find friends',
    },
    /** 20. 10. 2026 (owner). */
    following: {
      title: 'Nobody you follow made news',
      body: 'Follow survivors from the Survivors list: their Legendaries, level-ups, the Sunday boss and Wanted show up here.',
      action: 'Find survivors',
    },
  },
} as const;
